import { BrowserRouter, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import AppRoutes from "./routes/AppRoutes";
import ScrollToTop from "./components/ScrollToTop";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ToastContainer } from "react-toastify";

const queryClient = new QueryClient();

function AppContent() {
  const location = useLocation();

  const isCheckInPage = location.pathname === "/subscription/check-in";

  const isLegalPage =
    location.pathname === "/privacy-policy" ||
    location.pathname === "/terms-and-conditions";

  const showNavbar = !isCheckInPage && !isLegalPage;
  const showFooter = !isLegalPage;

  return (
    <>
      {showNavbar && <Navbar />}
      <main className="min-h-screen">
        <AppRoutes />
      </main>
      {showFooter && <Footer />}
    </>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ScrollToTop />
        <AuthProvider>
          <AppContent />
          <ToastContainer
            position="bottom-center"
            theme="colored"
            pauseOnHover={false}
            pauseOnFocusLoss={false}
            style={{ bottom: "20px" }}
            toastStyle={{
              marginBottom: "10px",
              paddingRight: "40px",
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
